import { CompanyAccess, PermissionScope } from "@me-team/host/main/graphql/types";
import AccessService from "@me-team/host/services/AccessService";

export interface RoutePermissionAccessConfig {
    permission?: CompanyAccess;
    anyPermissions?: CompanyAccess[];
    allPermissions?: CompanyAccess[];
    scope?: PermissionScope;
}

export const hasRoutePermissionConfig = ({
    permission,
    anyPermissions,
    allPermissions,
}: Omit<RoutePermissionAccessConfig, "scope">): boolean => {
    return permission != null || Array.isArray(anyPermissions) || Array.isArray(allPermissions);
};

export const hasRoutePermissionAccess = (
    accessServiceInstance: AccessService,
    { permission, anyPermissions, allPermissions, scope }: RoutePermissionAccessConfig
): boolean => {
    const hasPermissionSelector = permission != null;
    const hasAnySelector = Array.isArray(anyPermissions);
    const hasAllSelector = Array.isArray(allPermissions);
    const selectorCount = Number(hasPermissionSelector) + Number(hasAnySelector) + Number(hasAllSelector);

    if (selectorCount === 0) {
        return true;
    }

    if (selectorCount !== 1) {
        return false;
    }

    if (hasPermissionSelector) {
        return accessServiceInstance.hasPermission(permission!, { scope });
    }

    if (hasAnySelector) {
        return anyPermissions!.length > 0 ? accessServiceInstance.hasAnyPermission(anyPermissions!, { scope }) : false;
    }

    return allPermissions!.length > 0 ? accessServiceInstance.hasAllPermissions(allPermissions!, { scope }) : false;
};

export const isRoutePermissionAccessPending = (
    accessServiceInstance: AccessService,
    isReady: boolean,
    hasPermissionConfig: boolean
): boolean => {
    return (
        hasPermissionConfig &&
        (!isReady || !accessServiceInstance.isRoleAccessReady() || accessServiceInstance.isRoleAccessLoading())
    );
};
